import { danger } from '../../../../../utils/brandColors';

export default () => ({
  editButton: { marginLeft: '4px' },
  nameTypography: { cursor: 'pointer' },
  error: { color: danger[500] },
  footer: {
    textAlign: 'right',
    padding: '1rem',
  },
  right: { textAlign: 'right' },
  textField: {
    marginLeft: 25,
    marginRight: 25,
    width: 200,
  },
});
